<template>
    <csp-layout-default>
        <div class="header">
            <h1>
                Aufnahme Ihrer Schadeninformationen
            </h1>
        </div>

        <b-alert v-if="isLoadingLoginStatus" show variant="info">
            Initialisiere Unfallerfassung...
        </b-alert>

        <b-alert v-if="hasLoginStatusError" show variant="warning">
            Die Sitzung ist abgelaufen. Bitte Scannen Sie den QR-Code erneut.
        </b-alert>

        <router-view v-if="isUserLoggedIn"/>
    </csp-layout-default>
</template>

<script>
    import Container from '../../lib/services/Container';
    import RemoteAccessTypeEnum from '@js/enums/RemoteAccessTypeEnum';

    export default {
        data() {
            return {
                isLoadingLoginStatus: true,
                hasLoginStatusError: false,
            }
        },
        computed: {
            isUserLoggedIn() {
                return !this.isLoadingLoginStatus
                    && !this.hasLoginStatusError
                    && this.loginStatusStore.isLoggedIn();
            },
        },
        mounted() {
            const container = Container.getInstance();
            this.authRepository = container.getAuthRepository();
            this.loginStatusStore = container.getLoginStatusStore();

            this.loadLoginStatus();
        },
        methods: {
            loadLoginStatus() {
                this.authRepository.getUserInfo().then(
                    (data) => {
                        this.loginStatusStore.setCurrentUser(data);
                    },
                    () => {
                        this.hasLoginStatusError = true;
                    }
                ).finally(() => {
                    if (!this.loginStatusStore.isLoggedIn()) {
                        this.hasLoginStatusError = true;
                    }
                    const remoteAccessType = this.loginStatusStore.getRemoteAccessType();
                    if (!(
                        remoteAccessType === RemoteAccessTypeEnum.DAMAGE_RECORD_CREATION_BY_CUSTOMER
                        || remoteAccessType === RemoteAccessTypeEnum.DAMAGE_RECORD_CREATION_BY_CUSTOMER_INDIVIDUAL
                    )) {
                        this.hasLoginStatusError = true;
                    }

                    this.isLoadingLoginStatus = false;
                });
            },
        },
    }
</script>
